module.exports = __webpack_public_path__ + "img/6.5-Table-Separated-Rows.e829bf3f.png";